import { useEffect, useState } from 'react';
import QRCode from "react-qr-code";
import { apiNotificationBaseUrl, uploadDocBaseUrl } from '../../config/GlobalConfig';
import useAppState from '../../context/AppContext';

type QrCodeCompnentProps = {
    onEventMessage?: (message: any, type: string) => void;
    eventId: string;
    docCode: string;
    docId?: string;
    onTimeoutMessage?: () => void;
};

export default function QrCodeComponent({ onEventMessage, docCode, eventId, docId, onTimeoutMessage}: QrCodeCompnentProps) { 
    const {
        state: { proposition, jwtToken },
      } = useAppState();
   
    const [loading, setLoading] = useState(false);

    let qrCodeUrl = `${uploadDocBaseUrl}?propositionId=${proposition?.propositionId}&docCode=${docCode}&eventId=${eventId}&token=${jwtToken?.accessToken}`;

    if (docId) {
        qrCodeUrl = `${uploadDocBaseUrl}?propositionId=${proposition?.propositionId}&docCode=${docCode}&docId=${docId}&eventId=${eventId}&token=${jwtToken?.accessToken}`;
    }
    
    console.log(qrCodeUrl);


    useEffect(() => {
        let waitingTime = 0;
        let doneUpload = false;
        let timerEventUploadSource: ReturnType<typeof setTimeout>;
        let token = jwtToken?.accessToken;
        let eventUploadSource: EventSource;
        let eventOpenLink: EventSource;

        function initEventUploadLink() {
            let eventOpenLink = new EventSource(`${apiNotificationBaseUrl}/events/sse-events/${eventId}_open?token=${token}`);
            eventOpenLink.onopen = (event) => {
                console.log("Start Waiting for", event);
            }

            eventOpenLink.addEventListener("last-message-event", (event) => {
                console.log("Event notified:", event.data);
                eventOpenLink.close();
                initEventUploadSource(); 
                setLoading(true);
            });
            
            eventOpenLink.onerror = (event) => {
                console.log("Error of event", event);
                eventOpenLink.close();
                if(onTimeoutMessage) {
                    onTimeoutMessage();
                }
            }
        }


        function initEventUploadSource() {
            let eventUploadSource = new EventSource(`${apiNotificationBaseUrl}/events/sse-events/${eventId}?token=${token}`);
            eventUploadSource.onopen = (event) => {
                console.log("Start Waiting for", event);
            }

            eventUploadSource.addEventListener("last-message-event", (event) => {
                console.log("Event notified:", event.data);
                setLoading(false);
            
                const data = JSON.parse(event.data);
                if(onEventMessage) {
                    const eventMsg = JSON.parse(data.message);
                    eventMsg.fileType = docCode;
                    onEventMessage(eventMsg, 'upload');
                }
            
                eventUploadSource.close();
                doneUpload = true;
                if(timerEventUploadSource) {
                    clearTimeout(timerEventUploadSource);
                }
            });
            
            eventUploadSource.onerror = (event) => {
                console.log("Error of event", event);
                eventUploadSource.close();
                if(waitingTime < 4) {
                    timerEventUploadSource = setTimeout(initEventUploadSource, 120);
                } else {
                    setLoading(false);
                    if(timerEventUploadSource) {
                        clearTimeout(timerEventUploadSource);
                    }
                    if(onTimeoutMessage) {
                        onTimeoutMessage();
                    }
                }
                waitingTime++;               
            }
        }

        initEventUploadLink();

        return () => {
            if(timerEventUploadSource) {
                clearTimeout(timerEventUploadSource);
            }
            if(eventUploadSource) {
                eventUploadSource.close();
            }
            if (eventOpenLink) {
                eventOpenLink.close();
            }
            
            console.log("eventsource closed")
        }

    }, [eventId])
    
    return(
        <>
        {loading&& <div className="p-md ta-center">            
                    <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/loader.gif"} width="80" height="80" style={{boxShadow: "none"}} />   
                    <div className="p-sm">Traitement en cours, merci de patienter...</div> 
                </div>}
        {!loading&&<div className="" style={{ height: "auto", margin: "0 auto", maxWidth: '50%', width: "100%" }}>
            <QRCode
                size={256}
                style={{ height: "auto", maxWidth: "100%", width: "100%", }}
                fgColor='#144196'
                bgColor='#FFFFFF'
                value={qrCodeUrl}
                viewBox={`0 0 256 256`}
             />
        </div>}
        </>
    )
}